// This file was generated by lezer-generator. You probably shouldn't edit it.
import { LRParser } from "@lezer/lr";
const spec_Name = { __proto__: null, PI: 28, AVERAGE: 34 };
export const presetFormulaParser = LRParser.deserialize({
  version: 14,
  states:
    "%WOVQPOOQhQPOOOVQPO'#C`OOQO'#Ch'#ChOvQPO'#CgOOQO'#Cl'#ClO{QPO'#CkOOQO'#Ct'#CtOOQO'#Ca'#CaOOQO'#Cb'#CbOOQO'#Cc'#CcOOQO'#Cd'#CdOVQPO,58zOVQPO,58zOhQPO,58zO!QQPO,59RO!VQPO,59VOOQO1G.f1G.fO!bQPO1G.fOVQPO1G.fOVQPO1G.fOOQO1G.m1G.mOOQO'#Co'#CoO!vQPO'#CnO!{QPO1G.qO#QQPO7+$QO#cQPO7+$QO!VQPO,59YOOQO7+$]7+$]OOQO<<Gl<<GlO#tQPO1G.tOOQO1G.t1G.t",
  stateData:
    "#|~OgOS~OQVORVOXQO^ROaTO~OiWOjXOkYOlZO~OX_O~OX`O~OYeO~OQfORfO^RO~OiWOjXOeSikSilSiYSi~OdkO~OYlO~OYmOiSijSikSilSi~OYmOiWOjXOkSilSi~OdkOYbi~O",
  goto: "#`iPPPPjrrzzPP!Q!^PPj!hP!p!vPPPP!|]VOQ[]cdU[PbjRc^Q]PRd^[VOQ[]cdTf`kaSOQ[]`cdk]UOQ[]cdQh`RokQg`RnkQPOQ^QQa[Qb]QicRjd",
  nodeNames:
    "⚠ Formula Number Variable NumericExpression MultiplicationOperator DivisionOperator AdditionOperator SubtractionOperator OpeningBracket ClosingBracket PiFunction Keyword Name PI AverageFunction Keyword AVERAGE AverageFunctionInput Atom Comma",
  maxTerm: 28,
  skippedNodes: [0, 13],
  repeatNodeCount: 0,
  tokenData:
    "&[~ReX^!dpq!dtu#Xxy#yyz$Oz{$T{|$Y|}$_}!O$d!P!Q$i!Q![$n!c!}&P#T#o&P#y#z!d$f$g!d#BY#BZ!d$IS$I_!d$I|$JO!d$JT$JU!d$KV$KW!d&FU&FV!d~!iYg~X^!dpq!d#y#z!d$f$g!d#BY#BZ!d$IS$I_!d$I|$JO!d$JT$JU!d$KV$KW!d&FU&FV!d~#[S!Q![#h!c!}#h#R#S#h#T#o#h~#mSR~!Q![#h!c!}#h#R#S#h#T#o#h~$OOX~~$TOY~~$YOi~~$_Ok~~$dOd~~$iOl~~$nOj~~$sSQ~!O!P%P!Q![$n!g!h%e#X#Y%e~%SP!Q![%V~%[RQ~!Q![%V!g!h%e#X#Y%e~%hR{|%q}!O%q!Q![%w~%tP!Q![%w~%|PQ~!Q![%w~&UQ]~!c!}&P#T#o&P",
  tokenizers: [0],
  topRules: { Formula: [0, 1] },
  specialized: [{ term: 13, get: (value: keyof typeof spec_Name) => spec_Name[value] || -1 }],
  tokenPrec: 0,
  termNames: {
    "0": "⚠",
    "1": "@top",
    "2": "Number",
    "3": "Variable",
    "4": "NumericExpression",
    "5": "MultiplicationOperator",
    "6": "DivisionOperator",
    "7": "AdditionOperator",
    "8": "SubtractionOperator",
    "9": "OpeningBracket",
    "10": "ClosingBracket",
    "11": "PiFunction",
    "12": 'Keyword<"PI">',
    "13": "Name",
    "14": 'Name/"PI"',
    "15": "AverageFunction",
    "16": 'Keyword<"AVERAGE">',
    "17": 'Name/"AVERAGE"',
    "18": "AverageFunctionInput",
    "19": "Atom",
    "20": "Comma",
    "21": "␄",
    "22": "%mainskip",
    "23": "space",
    "24": "expression",
    "25": '"*"',
    "26": '"/"',
    "27": '"+"',
    "28": '"-"',
  },
});
